module.exports = __webpack_public_path__ + "static/img/HighEnd.4974428.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HighEnd.png
// module id = gAkt
// module chunks = 20